import { IConfig } from '../../adapter';
import { namespace, version } from '../../globals';
import { uuid } from '@roai/shared';
import { generateDeviceFingerprint } from '../device-info/device';
export interface ICommonInfo {
  sessionId: Nullable<string>;
  preSessionId: Nullable<string>;
  appId: string;
  appVersion: string;
  deviceId: string;
  sdkVersion: string;
  platform: string;
  dataVersion: string;
  bizType: string;
}

const id = `__TD_${namespace}_session_id__`;

class Common {
  private sessionId: string = '';
  private preSessionId: string = '';
  private config: Pick<IConfig, 'bizType' | 'storage'>;
  private storage: IConfig['storage'];

  constructor(config: Pick<IConfig, 'bizType' | 'storage'>) {
    this.config = config;
    this.storage = config.storage;
  }

  private async getPreSessionId() {
    if (this.preSessionId) {
      return this.preSessionId;
    }

    // 顺序不能乱
    const preSessionId = await this.storage.getItem(id) || '';
    await this.cachePreSessionId(); 
    this.preSessionId = preSessionId;

    return preSessionId;
  }

  // 将当前的 sessionId 写入缓存，下次会话开始作为 preSessionId，只能在获取到了 preSessionId 之后才能调用
  private async cachePreSessionId() {
    if (this.sessionId) {
      await this.storage.setItem(id, this.sessionId);
    }
  }

  private getSessionId() {
    if (this.sessionId) {
      return this.sessionId;
    }

    const sessionId = uuid();
    this.sessionId = sessionId;

    return sessionId;
  }

  public async getCommonInfo(): Promise<ICommonInfo> {
    const sessionId = this.getSessionId();
    const preSessionId = await this.getPreSessionId();
    const deviceId = await generateDeviceFingerprint(this.storage);

    return {
      sessionId,
      preSessionId,
      appId: location.host ? location.host : 'no host app',
      appVersion: '1.0.0',
      deviceId,
      sdkVersion: version,
      platform: 'web',
      dataVersion: '1.0',
      bizType: this.config.bizType,
    }
  }
}

export default Common;
